"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIGS = void 0;
var e2e_1 = require("./e2e");
var ropsten_1 = require("./ropsten");
var rinkeby_1 = require("./rinkeby");
var mainnet_1 = require("./mainnet");
exports.CONFIGS = {
    e2e: e2e_1.E2E_CONFIG,
    ropsten: ropsten_1.ROPSTEN_CONFIG,
    rinkeby: rinkeby_1.RINKEBY_CONFIG,
    mainnet: mainnet_1.MAINNET_CONFIG
};
